import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { GeneralResMock } from '../types/general.type'
import { ProceedResMock } from '../types/proceed.type'

type Props = {
  id?: string
  page?: number
  limit?: number
  query?: string
  sortDir?: 'asc' | 'desc'
  sort_by?: string
}
export const useProcedure = (arg?: Props) => {
  const id = arg?.id
  const query = arg?.query
  const pageCount = arg?.limit
  const page = arg?.page
  const sort_dir = arg?.sortDir || 'asc'
  const sort_by = arg?.sort_by || 'created_at'

  const { data: procedures, isLoading: procedureIsLoading } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<ProceedResMock[]>>('procedures', {
        params: {
          ...(sort_dir && { sort_dir }),
          ...(page && { 'page[number]': page }),
          ...(pageCount && { 'page[size]': pageCount }),
          ...(sort_by && { sort_by }),
          ...(query && { query })
        }
      })
      return data
    },
    queryKey: ['procedure', { page, pageCount, query, sort_by, sort_dir }]
  })

  const { data: singleProcedure, isLoading: singleProcedureIsLoading } = useQuery({
    enabled: !!id,
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<ProceedResMock>>(`procedures/${id}`)
      return data.data
    },
    queryKey: ['procedure', { id }]
  })

  const { mutateAsync: createProcedure } = useMutation({
    mutationFn: async (formRec: any) => {
      const { data } = await AXIOS_INSTANCE.post('procedures', formRec, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['procedure'] })
  })

  const { mutateAsync: updateProcedure } = useMutation({
    mutationFn: async ({ formVal, id }: { formVal: any; id: string }) => {
      const { data } = await AXIOS_INSTANCE.patch(`procedures/${id}`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['procedure'] })
    }
  })

  const { mutateAsync: deleteProcedure } = useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      await AXIOS_INSTANCE.delete(`procedures/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['procedure'] })
    }
  })

  return {
    createProcedure,
    deleteProcedure,
    pagination: procedures?.meta.pagination,
    procedureIsLoading,
    procedures: procedures?.data,
    singleProcedure,
    singleProcedureIsLoading,
    updateProcedure
  }
}
